// GENERATED by shared/tools/story/build-books.ts from story/book-1-the-purple-egg.md. Do not edit:
// change the book (story/README.md) and run the build again.
import type { Book } from './types.js';

export const BOOK_1: Book = {
  "number": 1,
  "title": "Book One: The Purple Egg",
  "worldId": "w1",
  "tagline": "A forest is losing its color. A brave boy and his new Suikamon try to bring back its light.",
  "plannedBattles": 23,
  "chapters": [
    {
      "number": 1,
      "title": "The Purple Egg",
      "status": "final",
      "items": [
        {
          "page": {
            "id": "open-0-suikara",
            "isNew": false,
            "twist": false,
            "caption": "Suikara",
            "alt": "A sunny island village by the sea where people and Suikamon live side by side: Gorly carries a basket with a farmer, Fernail swims by a fishing boat, a songbird rides a child's shoulder, and Drago warms a baker's oven.",
            "cast": [
              "sp:gorly",
              "sp:fernail",
              "sp:bireon",
              "sp:drago"
            ],
            "refs": [
              "sp:gorly",
              "sp:fernail",
              "sp:bireon",
              "sp:drago"
            ],
            "brief": "a sunny island village by the sea: the big creature from the first reference carries a fruit basket beside a farmer, the creature from the second reference swims by a fishing boat, the bird from the third reference rides a child's shoulder, the creature from the fourth reference warms a baker's oven, and far up on green hills small wild creatures run free",
            "lines": [
              {
                "who": "narrator",
                "text": "On the island of Suikara, people and Suikamon live side by side."
              },
              {
                "who": "narrator",
                "text": "Many Suikamon still run wild in the hills."
              }
            ]
          }
        },
        {
          "page": {
            "id": "b1-c1-egg",
            "isNew": true,
            "twist": false,
            "caption": "THUMP!",
            "alt": "Kai sits in a leafy bush under a snapped branch, a leaf in his hair, staring at a big purple egg between two mossy roots; across the stream the grass is gray and a cold mist drifts through bare trees.",
            "cast": [
              "player"
            ],
            "refs": [
              "player",
              "prop:egg"
            ],
            "brief": "by a stream in the woods: the boy from the first reference sits in a leafy bush under a snapped branch, a dry leaf in his hair, staring wide-eyed at the egg from the second reference, drawn exactly like it with no extra mark, big as his head, between two mossy roots; across the stream gray grass, bare trees and a cold mist, and NO creature anywhere in the picture",
            "lines": [
              {
                "who": "kai",
                "text": "Good news, bush: you caught me!"
              },
              {
                "who": "narrator",
                "text": "Kai is out for firewood. But each week, the cold gray mist creeps over more bare trees, closer to Gran's home."
              },
              {
                "who": "kai",
                "text": "Gran says: see the gray, come home. But what's inside this egg? I want to know!"
              }
            ]
          }
        },
        {
          "page": {
            "id": "b1-c1-hatch",
            "isNew": true,
            "twist": false,
            "caption": "POP!",
            "alt": "The purple egg cracks open in Kai's hands and bright light pours out, so bright that nothing inside can be seen.",
            "cast": [
              "player"
            ],
            "refs": [
              "player",
              "prop:egg-hatching"
            ],
            "brief": "in the woods by the stream, the boy from the first reference holds the hatching egg from the second reference in both hands, drawn exactly like it with no extra mark, as it bursts open, bright golden light pouring out so strongly that nothing inside can be seen, shell bits flying, a delighted laughing face, and NO creature anywhere in the picture",
            "lines": [
              {
                "who": "narrator",
                "text": "Light pours out, and a tiny {partner} tumbles into Kai's hands. It stares at a beetle, and Kai laughs."
              },
              {
                "who": "kai",
                "text": "Well, hello to you too!"
              }
            ]
          }
        },
        {
          "battle": {
            "nodeId": "z1-nw0",
            "encounterKind": "wild",
            "kind": "normal",
            "rivalName": "Wild Kobu",
            "rivalTitle": "Scared",
            "squad": [
              {
                "species": "Kobu",
                "nickname": "Scared Kobu"
              },
              {
                "species": "Pikoto",
                "nickname": "Pip"
              },
              {
                "species": "Gorly",
                "nickname": "Bramble"
              }
            ],
            "opponentCount": 1,
            "portrait": "Kobu",
            "shot": "close",
            "artIsNew": true,
            "alt": "On a forest path by the stream, a frightened wild Kobu with gray dust in its fur snarls and blocks the way, while Kai steps back hugging the two halves of the broken purple shell.",
            "refs": [
              "player",
              "sp:kobu@1",
              "prop:egg-hatching"
            ],
            "brief": "low view from where his unseen partner stands, on a forest path by a stream: the boy from the first reference steps back, startled but steady, as a scared wild cat creature from the second reference, cat-sized, head below his knee, gray dust in its fur, blocks the path; he hugs two broken halves of the empty shell from the third reference, NO whole egg, NO other creature",
            "story": "On the way home, a scared wild Kobu charges! Kai clutches the empty shell, and his little {partner} jumps in front!",
            "dialogue": {
              "intro": "Hsssss!",
              "playerWin": "The Kobu gives one last hiss, then runs off. Shaking, Kai whispers: thank you, little one.",
              "playerLose": "The scared Kobu holds the path. Try again!",
              "playerIntro": "You can do it!"
            }
          }
        },
        {
          "page": {
            "id": "b1-c1-door",
            "isNew": true,
            "twist": false,
            "caption": "Home.",
            "alt": "Late in the afternoon by the cottage door, Kai holds up three thin sticks and a broken purple shell, a sleeping bundle tucked in his arm, while Gran raises an eyebrow, hands on her hips.",
            "cast": [
              "player",
              "aggie"
            ],
            "refs": [
              "player",
              "aggie",
              "prop:egg-hatching"
            ],
            "brief": "late afternoon at a cosy cottage door: the boy from the first reference cradles a sleeping cloth bundle in his left arm, two broken shell halves from the third reference resting on it, and sheepishly raises three thin sticks in his right hand, while the old woman from the second reference, empty-handed and hands on hips, raises an eyebrow, NO creature visible",
            "lines": [
              {
                "who": "gran",
                "text": "Where's the firewood, love?"
              },
              {
                "who": "kai",
                "text": "Um, a few sticks? And a new friend, asleep under the shell! It hatched from an egg by the stream."
              }
            ]
          }
        },
        {
          "page": {
            "id": "b1-c1-shelf",
            "isNew": true,
            "twist": false,
            "caption": "Gran's secret.",
            "alt": "Inside the cottage late in the afternoon, Gran sets the purple shell pieces on the shelf by the fire and glances out of the window at the misty hills, while Kai watches with a sleeping bundle in his arms.",
            "cast": [
              "aggie",
              "player"
            ],
            "refs": [
              "aggie",
              "player",
              "prop:egg-hatching"
            ],
            "brief": "inside a cosy cottage in late afternoon, low golden sun through the window and a small fire just lit: the old woman from the first reference sets broken pieces of shell on a shelf above the fire, glancing worriedly out of a window at misty gray hills, while the boy from the second reference, holding a sleeping cloth bundle, glances down at the egg on his own T-shirt; the shell pieces are from the third reference, drawn exactly like it, and NO creature visible",
            "lines": [
              {
                "who": "gran",
                "text": "Most eggs are white. A purple one, just as the mist comes closer. That is no accident."
              },
              {
                "who": "kai",
                "text": "Wait... the egg you sewed on my shirt has the same swirls."
              },
              {
                "who": "gran",
                "text": "I copied it from my old book, long ago. Tonight I will read it to you, love."
              }
            ]
          }
        }
      ],
      "adaptedFrom": "e0f2b4d2de97",
      "zone": {
        "zoneId": "z1",
        "name": "The Purple Egg",
        "element": "Nature",
        "story": "A purple egg by the stream, and the Gray Mist on the other side."
      }
    },
    {
      "number": 2,
      "title": "Gran's Big Book",
      "status": "final",
      "items": [
        {
          "page": {
            "id": "b1-c2-ring",
            "isNew": true,
            "twist": false,
            "caption": "Timmy's ring!",
            "alt": "Before supper behind Timmy's house, Timmy proudly shows Kai his training ring: a square of flat stones with a flag at each corner and a big gong, Chirpy puffed up on his head.",
            "cast": [
              "timmy",
              "sp:bireon@1",
              "player"
            ],
            "refs": [
              "timmy",
              "sp:bireon@1",
              "player"
            ],
            "brief": "early evening, warm low sunlight, Timmy's ring (a low square platform of pale square tiles, four red corner pennants, a gong at the back), a straw dummy by a wooden fence: the loud boy from the first reference stands in the ring with arms spread wide, grinning proudly, the tiny chick from the second reference puffed up on his head, while the boy from the third reference stares at the ring amazed, NO other creature",
            "lines": [
              {
                "who": "timmy",
                "text": "I'm Timmy from next door, and this ring is where Chirpy and my three train!"
              }
            ]
          }
        },
        {
          "battle": {
            "nodeId": "z1-n1",
            "encounterKind": "trainer",
            "kind": "normal",
            "rivalName": "Timmy",
            "rivalTitle": "Boy next door",
            "squad": [
              {
                "species": "Bireon",
                "nickname": "Chirpy"
              },
              {
                "species": "Zaricat",
                "nickname": "Sparks"
              },
              {
                "species": "Sumiya",
                "nickname": "Pink Bunny"
              }
            ],
            "opponentCount": 1,
            "portrait": "Bireon",
            "shot": "medium",
            "artIsNew": true,
            "alt": "Before supper in Timmy's training ring, Timmy bangs his gong while his little yellow chick Chirpy hops forward on the stones, puffed up to look fierce.",
            "refs": [
              "timmy",
              "sp:bireon@1"
            ],
            "brief": "early evening, warm low sunlight, Timmy's ring (a low square platform of pale square tiles, four red corner pennants, a gong at the back): the loud boy from the first reference, no chick on his head, bangs the gong with a grin, while the fist-sized chick from the second reference hops forward across the tiles toward the viewer, feathers puffed up, trying hard to look fierce, NO other creature",
            "story": "Before supper, Timmy, the boy next door, takes Kai to his ring with his scorebook and his chick, Chirpy.",
            "dialogue": {
              "intro": "Mine are stronger! First, meet Chirpy! Attack, dodge or magic. Pick one!",
              "playerWin": "Ha! Three at once froze your {partner}, but one move won it. Tomorrow, a stronger one!",
              "playerLose": "One at a time! Watch Chirpy, then pick one move.",
              "playerIntro": "All three! Go!"
            }
          }
        },
        {
          "page": {
            "id": "open-2b-old-book",
            "isNew": true,
            "twist": false,
            "caption": "That night…",
            "alt": "At night in the cottage, Gran opens a huge old book with a dark cover on her knees, tiny silver lights dancing above it, while Kai and Timmy sit on the rug in pajamas and lean in.",
            "cast": [
              "aggie",
              "player",
              "timmy"
            ],
            "refs": [
              "aggie",
              "player",
              "timmy"
            ],
            "brief": "night inside a cosy cottage, warm lamplight and a fire: the old woman from the first reference sits in an armchair with a huge old book with a dark cover open on her knees, tiny silver lights dancing above it, while the boy from the second reference and the boy from the third reference, both in pajamas, sit on the rug and lean in, no chick on the second boy's head, NO creature",
            "lines": [
              {
                "who": "gran",
                "text": "Listen, love: this is the story of our island."
              }
            ]
          }
        },
        {
          "page": {
            "id": "b1-c2-temple",
            "isNew": true,
            "twist": false,
            "caption": "The Heart.",
            "alt": "A painted page: high in the mountains stands the Suikamon Temple, and at its center a great shining stone glows over people and Suikamon gathered together.",
            "cast": [
              "sp:gorly",
              "sp:bireon"
            ],
            "refs": [
              "sp:gorly",
              "sp:bireon"
            ],
            "brief": "a storybook painting of long ago: high in green mountains stands an old stone temple with open doors, and at its center a great stone glows with warm golden light; on the wide steps below, villagers sit side by side with friendly creatures like the first reference and the second reference, peaceful and warm, a painting only: no book, no page, no text",
            "lines": [
              {
                "who": "gran",
                "text": "Long ago, the Heart, a stone of light, united people and Suikamon in the Temple."
              }
            ]
          }
        },
        {
          "page": {
            "id": "b1-c2-heart-breaks",
            "isNew": true,
            "twist": false,
            "caption": "Soul Dust.",
            "alt": "A painted page: at night the temple doors have fallen, the great stone is cracked and dark, several small lights fly away into the sky, and silver dust drifts away on the wind.",
            "cast": [],
            "refs": [],
            "brief": "a storybook painting at night: the same old mountain temple, its big doors fallen, the great stone at its center cracked and dark, several small bright lights flying away in different directions over the island, and soft silver dust drifting on the wind, sad and mysterious, not scary, a painting only: no book, no text, NO creature or person",
            "lines": [
              {
                "who": "gran",
                "text": "One night it broke: its lights flew away, and its magic spread as Soul Dust."
              },
              {
                "who": "kai",
                "text": "Who broke it?"
              },
              {
                "who": "gran",
                "text": "I do not know the whole truth."
              }
            ]
          }
        },
        {
          "page": {
            "id": "open-3b-gray-spreads",
            "isNew": true,
            "twist": false,
            "caption": "The Gray Mist.",
            "alt": "A painted page: a cold gray mist rolls over a seaside village, its fruit trees bare and gray, while scared Suikamon run from the houses toward the wild hills.",
            "cast": [
              "sp:kobu",
              "sp:fernail"
            ],
            "refs": [
              "sp:kobu",
              "sp:fernail"
            ],
            "brief": "a storybook painting: a cold gray mist rolls over a seaside village, its fruit trees bare and gray, while scared creatures like the first reference and the second reference run away from the houses toward the wild hills, sad and gentle, a painting only: no book, no text, NO people in close view",
            "lines": [
              {
                "who": "gran",
                "text": "When the light was gone, the Gray Mist came, and scared Suikamon ran wild."
              },
              {
                "who": "kai",
                "text": "Is that why I never had one?"
              },
              {
                "who": "gran",
                "text": "A Suikamon has to choose you, love, and none came near us until your egg."
              }
            ]
          }
        },
        {
          "page": {
            "id": "b1-c2-eggs",
            "isNew": true,
            "twist": false,
            "caption": "Like my egg?",
            "alt": "In the lamplit cottage, Gran looks up from the big book while Kai, in pajamas, points at the purple shell pieces on the shelf by the fire, and Timmy stares.",
            "cast": [
              "aggie",
              "player",
              "timmy"
            ],
            "refs": [
              "aggie",
              "player",
              "timmy",
              "prop:egg-hatching"
            ],
            "brief": "a cosy cottage at night, lamplight: the old woman from the first reference looks up from a huge dark-brown leather book with brass corners on her knees; the boy from the second reference, in plain purple pajamas and his green beanie, jumps up pointing at a shelf above the fire; the boy from the third reference, in plain blue pajamas, stares; on the shelf, two EMPTY broken shell halves from the fourth reference, no whole egg, NO creature",
            "lines": [
              {
                "who": "gran",
                "text": "Soul Dust can turn an egg purple. Nineteen purple eggs hold clues to the lost light."
              },
              {
                "who": "kai",
                "text": "Then I'll find all nineteen!"
              },
              {
                "who": "gran",
                "text": "Not yet, love: care for your friend first."
              }
            ]
          }
        },
        {
          "battle": {
            "nodeId": "z1-n9",
            "encounterKind": "trainer",
            "kind": "normal",
            "rivalName": "Timmy",
            "rivalTitle": "Boy next door",
            "squad": [
              {
                "species": "Zaricat",
                "nickname": "Sparks"
              },
              {
                "species": "Bireon",
                "nickname": "Chirpy"
              },
              {
                "species": "Sumiya",
                "nickname": "Pink Bunny"
              }
            ],
            "opponentCount": 1,
            "portrait": "Zaricat",
            "shot": "close",
            "artIsNew": true,
            "alt": "The next morning in Timmy's training ring, his Zaricat Sparks charges at you before anyone says go, kicking up petals from the flowerbed, while Timmy laughs.",
            "refs": [
              "timmy",
              "sp:zaricat@2"
            ],
            "brief": "a sunny morning, close up, Timmy's ring (a low square platform of pale square tiles, four red corner pennants, a gong at the back), a flowerbed beside it: the loud boy from the first reference, no chick on his head, laughs with a small notebook in one hand, as the knee-high creature from the second reference charges right at the viewer, kicking up petals, NO other creature",
            "story": "Next morning, Kai runs back to Timmy's ring. Timmy's Zaricat, Sparks, charges before anyone says go.",
            "dialogue": {
              "intro": "Meet Sparks! He's faster than Chirpy, and he never waits.",
              "playerWin": "Sparks rolled right into the flowerbed! Next!",
              "playerLose": "Sparks wins! Dodge first next time."
            }
          }
        },
        {
          "battle": {
            "nodeId": "z1-n6",
            "encounterKind": "trainer",
            "kind": "normal",
            "rivalName": "Timmy",
            "rivalTitle": "Boy next door",
            "squad": [
              {
                "species": "Sumiya",
                "nickname": "Pink Bunny"
              },
              {
                "species": "Bireon",
                "nickname": "Chirpy"
              },
              {
                "species": "Zaricat",
                "nickname": "Sparks"
              }
            ],
            "opponentCount": 1,
            "portrait": "Sumiya",
            "shot": "medium",
            "artIsNew": true,
            "alt": "In Timmy's training ring, Timmy points, his scorebook in his other hand, while his pink bunny bounces onto the stones, ready to battle.",
            "refs": [
              "timmy",
              "sp:sumiya@2"
            ],
            "brief": "a sunny morning, Timmy's ring (a low square platform of pale square tiles, four red corner pennants, a gong at the back): the boy from the first reference, no chick on his head, points forward proudly, a small notebook in his other hand, while the knee-high pink bunny from the second reference bounces onto the tiles, bright and playful, ready to battle, NO other creature",
            "story": "Timmy points, and his pink bunny bounces into the ring to face Kai.",
            "dialogue": {
              "intro": "Meet my bunny! Stronger than Sparks. She's only lost once. To a leaf.",
              "playerWin": "Two losses now: a leaf, and you!",
              "playerLose": "Ha! My bunny wins! Writing that one down!"
            }
          }
        },
        {
          "battle": {
            "nodeId": "z1-n10",
            "encounterKind": "trainer",
            "kind": "mini_boss",
            "rivalName": "Timmy",
            "rivalTitle": "Boy next door",
            "squad": [
              {
                "species": "Aqua",
                "nickname": "Splash"
              },
              {
                "species": "Bireon",
                "nickname": "Chirpy"
              },
              {
                "species": "Sumiya",
                "nickname": "Pink Bunny"
              }
            ],
            "opponentCount": 1,
            "portrait": "Aqua",
            "shot": "wide",
            "artIsNew": true,
            "alt": "A wide view of Timmy's training ring: Timmy bangs the gong as his calm blue Aqua, Splash, steps onto the stones to face you, cool as a pond.",
            "refs": [
              "timmy",
              "sp:aqua@2"
            ],
            "brief": "a wide view on a sunny morning of Timmy's ring (a low square platform of pale square tiles, four red corner pennants, a gong at the back): the boy from the first reference, no chick on his head, bangs the gong, tense and excited, as the knee-high calm blue creature from the second reference steps onto the tiles toward the viewer, steady and clever-eyed, NO other creature",
            "story": "Timmy bangs the gong. His strongest, the Aqua Splash, steps into the ring to face Kai, calm as a pond.",
            "dialogue": {
              "intro": "My strongest: Splash! Nobody has ever beaten Splash.",
              "playerWin": "Four wins. You're the champion!",
              "playerLose": "Splash wins! Come back and try again!"
            }
          }
        },
        {
          "page": {
            "id": "w1-intro-2",
            "isNew": true,
            "twist": true,
            "caption": "A monster?!",
            "alt": "A huge red-maned Gorly has broken Gran's fence and pulls the last apples off her apple tree, while Kai and Timmy peek from behind a bush.",
            "cast": [
              "sp:gorly@5",
              "player",
              "timmy"
            ],
            "refs": [
              "sp:gorly@5",
              "player",
              "timmy"
            ],
            "brief": "a cottage garden in the morning: the huge round red-maned creature from the first reference, drawn exactly like it, big belly and all, twice as tall as the boys, mouth open showing big teeth, stands by a smashed fence pulling the last red apples off a small apple tree, while the boy from the second reference and the boy from the third reference, no chick on him, peek out from behind a bush, NO other creature",
            "lines": [
              {
                "who": "narrator",
                "text": "CRASH! A wild Gorly is pulling the apples off Gran's tree!"
              },
              {
                "who": "timmy",
                "text": "Look at those teeth!"
              }
            ]
          }
        },
        {
          "page": {
            "id": "b1-c2-apples",
            "isNew": true,
            "twist": false,
            "caption": "Just hungry.",
            "alt": "Kai kneels and rolls an apple across the grass to the huge, round Gorly by the broken fence; she looks down at it with sad, hungry eyes.",
            "cast": [
              "player",
              "sp:gorly@5"
            ],
            "refs": [
              "player",
              "sp:gorly@5"
            ],
            "brief": "morning in a cottage garden by a broken fence: the boy from the first reference kneels, rolling a red apple toward the huge round red-maned creature from the second reference, drawn exactly like it, big belly and all, towering twice his height, one paw on its rumbling tummy, sad hungry eyes, not smiling; a second apple rolls in from the frame's edge, gentle and tense, ONE big creature only",
            "lines": [
              {
                "who": "kai",
                "text": "She's not a monster. She's just hungry."
              },
              {
                "who": "narrator",
                "text": "Kai and his {partner} roll her two apples, and the Gorly stares at Kai."
              }
            ]
          }
        },
        {
          "page": {
            "id": "b1-c2-dust",
            "isNew": true,
            "twist": false,
            "caption": "Soul Dust!",
            "alt": "Small silver lights rise from the grass where the apple rolled and drift into the cottage, while Kai, Timmy and Gran watch beside the bare, graying apple tree.",
            "cast": [
              "player",
              "timmy",
              "aggie"
            ],
            "refs": [
              "player",
              "timmy",
              "aggie"
            ],
            "brief": "a cottage garden in the morning by a broken fence: the apple tree stripped of its apples, its leaves turning gray, and from the grass small silver sparkling lights float up toward the open cottage door; the boy from the first reference and the boy from the second reference, no chick on him, watch in wonder from the grass, and the old woman from the third reference from the doorway, NO creature",
            "lines": [
              {
                "who": "gran",
                "text": "Soul Dust! Perhaps it shines when people and Suikamon help each other."
              },
              {
                "who": "gran",
                "text": "But the Gray has reached our garden."
              },
              {
                "who": "kai",
                "text": "Everyone says the Mist comes from the Gray Forest, so that is where I'll go!"
              }
            ]
          }
        },
        {
          "page": {
            "id": "intro-5-be-a-friend",
            "isNew": true,
            "twist": false,
            "caption": "Gran's hug.",
            "alt": "In Gran's garden, by the broken fence and the graying apple tree, Gran kneels and hugs Kai tight.",
            "cast": [
              "player",
              "aggie"
            ],
            "refs": [
              "player",
              "aggie"
            ],
            "brief": "a green summer cottage garden in the morning, a broken wooden fence and the apple tree stripped of its apples, its leaves turning gray: the old woman from the second reference kneels and hugs the boy from the first reference tight, eyes closed, tender and brave, no frost and no snow, and NO creature anywhere in the picture",
            "lines": [
              {
                "who": "gran",
                "text": "Last night I said not yet, to keep you safe, but the danger found us anyway."
              }
            ]
          }
        },
        {
          "page": {
            "id": "w1-intro-5",
            "isNew": true,
            "twist": false,
            "caption": "Gran's gift.",
            "alt": "Gran takes her big old book from the shelf and puts it in Kai's hands; tiny silver lights dance above its dark cover.",
            "cast": [
              "aggie",
              "player"
            ],
            "refs": [
              "aggie",
              "player"
            ],
            "brief": "inside the cosy cottage in morning light, by a wooden bookshelf with an empty gap: the old woman from the first reference lays a huge old book with a dark cover into the open hands of the boy from the second reference, tiny silver lights dancing above the cover, solemn and wondrous, and NO creature anywhere in the picture",
            "lines": [
              {
                "who": "gran",
                "text": "Take my book, the Shard Book. Its blank pages wait for the shards, the pieces of the lost light. The purple eggs may lead you to them."
              },
              {
                "who": "gran",
                "text": "Cliff guards the gate to the Gray Forest: ask him what he has seen."
              }
            ]
          }
        }
      ],
      "adaptedFrom": "e39e003730e4",
      "zone": {
        "zoneId": "z2",
        "name": "Gran's Big Book",
        "element": "Nature",
        "story": "Gran reads the story of the lost light, and the Gray reaches her garden."
      }
    },
    {
      "number": 3,
      "title": "The Gate to the Gray Forest",
      "status": "final",
      "items": [
        {
          "battle": {
            "nodeId": "z1-n4",
            "encounterKind": "trainer",
            "kind": "mini_boss",
            "rivalName": "Cliff",
            "rivalTitle": "Gatekeeper",
            "squad": [
              {
                "species": "Pikoto",
                "nickname": "Pikoto"
              },
              {
                "species": "Ray",
                "nickname": "Thistle"
              },
              {
                "species": "Gorly",
                "nickname": "Boulder"
              }
            ],
            "opponentCount": 1,
            "portrait": "Pikoto",
            "shot": "wide",
            "artIsNew": true,
            "alt": "Cliff stands with his arms crossed in front of his closed gate, his Pikoto glaring just as grumpily at his side, the bare gray forest misty beyond.",
            "refs": [
              "cliff",
              "sp:pikoto@2"
            ],
            "brief": "late morning at a tall closed plank gate with a blank sign and a narrow gap by its post, a gray misty forest beyond: the bearded man from the first reference stands in front of it, arms crossed, a coil of rope on his shoulder, scowling, and the green bird from the second reference at his knee glares just as grumpily, NO other creature",
            "story": "Later that morning, Kai asks Cliff, the grumpy gatekeeper, to open the gate to the Gray Forest.",
            "dialogue": {
              "intro": "No. My sister went into the Gray and forgot our mother's name.",
              "playerWin": "You watched first, then picked your move. Good. But the gate stays closed.",
              "playerLose": "You rushed. Go home, kid.",
              "playerIntro": "But the Gray's already in Gran's garden! Test us, then."
            }
          }
        },
        {
          "page": {
            "id": "b1-c3-bridge",
            "isNew": true,
            "twist": false,
            "caption": "Eeeee!",
            "alt": "Just past the gate, Kai kneels on an old rope bridge over a rushing stream, tugging at a branch that pins a little Ray cub's foot, while a plank cracks under his shoe and Cliff shouts from the gate.",
            "cast": [
              "player",
              "sp:ray@2",
              "cliff"
            ],
            "refs": [
              "player",
              "sp:ray@2",
              "cliff"
            ],
            "brief": "wide side-on shot: a sagging rope-and-plank bridge high above a rushing rocky gorge, gray misty bare trees on the far side; the boy from the first reference kneels on it tugging a branch off the foot of the small cub from the second reference, no bigger than his chest; a plank splits under his own shoe; the bearded man from the third reference shouts from a plank gate behind, NO other creature",
            "lines": [
              {
                "who": "narrator",
                "text": "A little Ray cries on an old bridge past the gate: a branch pins its foot! Without thinking, Kai squeezes through a gap and onto the bridge."
              },
              {
                "who": "kai",
                "text": "A plank cracked! That was a bad idea, and this branch won't budge!"
              },
              {
                "who": "cliff",
                "text": "Stop pulling! The bridge could fall!"
              }
            ]
          }
        },
        {
          "page": {
            "id": "b1-c3-rope",
            "isNew": true,
            "twist": false,
            "caption": "Think fast.",
            "alt": "Cliff knots his rope to the gatepost while his Pikoto flies the other end across to Kai on the bridge.",
            "cast": [
              "cliff",
              "sp:pikoto@2",
              "player",
              "sp:ray@2"
            ],
            "refs": [
              "cliff",
              "sp:pikoto@2",
              "player",
              "sp:ray@2"
            ],
            "brief": "the same sagging rope-and-plank bridge high over a rushing gorge, gray misty trees beyond: the bearded man from the first reference knots a rope to a wooden gatepost, the green bird from the second reference flies its end across in its beak to the boy from the third reference, kneeling worried with a hand on the branch still pinning the small cub from the fourth reference, NO other creature",
            "lines": [
              {
                "who": "kai",
                "text": "Cliff, stay by the post: the planks won't hold us both!"
              },
              {
                "who": "kai",
                "text": "Tie your shoulder rope to the post, and your Pikoto can fly me the end!"
              }
            ]
          }
        },
        {
          "page": {
            "id": "b1-c3-fall",
            "isNew": true,
            "twist": false,
            "caption": "CRASH!",
            "alt": "The old bridge falls into the stream as Kai swings on the rope with the little Ray in one arm, and Cliff hauls them back from the gatepost.",
            "cast": [
              "player",
              "sp:ray@2",
              "cliff"
            ],
            "refs": [
              "player",
              "sp:ray@2",
              "cliff"
            ],
            "brief": "the old rope bridge falls apart into the rushing stream: the boy from the first reference swings on a rope, holding the small cub from the second reference safe in one arm, while the bearded man from the third reference hauls the rope from the gatepost with all his strength, planks tumbling, dramatic and hopeful, NO other creature",
            "lines": [
              {
                "who": "narrator",
                "text": "Kai and his {partner} heave the branch, and this time it ignores the beetle on it. The Ray is free! Then the bridge gives way."
              },
              {
                "who": "narrator",
                "text": "Cliff hauls Kai, his {partner} and the Ray back through the gap."
              }
            ]
          }
        },
        {
          "battle": {
            "nodeId": "z1-nw2",
            "encounterKind": "wild",
            "kind": "normal",
            "rivalName": "Little Ray",
            "rivalTitle": "Scared cub",
            "squad": [
              {
                "species": "Ray",
                "nickname": "Little Ray"
              },
              {
                "species": "Kobu",
                "nickname": "Moss"
              },
              {
                "species": "Pikoto",
                "nickname": "Fluff"
              }
            ],
            "opponentCount": 1,
            "portrait": "Ray",
            "shot": "medium",
            "artIsNew": true,
            "alt": "On the grass by the gate, the terrified little Ray backs against the gate post, thorny tail lashing, while Cliff shakes his scratched hand and Kai kneels, calm.",
            "refs": [
              "sp:ray@2",
              "cliff",
              "player"
            ],
            "brief": "on the grass by a tall wooden plank gate, gray misty forest beyond: the small cub from the first reference, no bigger than the kneeling boy's chest, terrified, backs against the gatepost swiping, thorny tail lashing, while the bearded man from the second reference shakes a scratched hand, and the boy from the third reference kneels calmly, palms open, NO other creature",
            "story": "Safe on the grass, the little Ray is still terrified. It scratches Cliff's hand and backs against the gate, so Kai steps in!",
            "dialogue": {
              "intro": "Grrrr! Eeeee!",
              "playerWin": "The Ray stops shaking. Silver specks fall from its fur.",
              "playerLose": "The scared Ray swipes again. Gently, Kai. Try again!"
            }
          }
        },
        {
          "page": {
            "id": "b1-c3-dust",
            "isNew": true,
            "twist": false,
            "caption": "Calm at last.",
            "alt": "Kai sits on the grass with the Shard Book flashing in his lap as silver specks float up from the calm little Ray, now resting in Cliff's arms.",
            "cast": [
              "player",
              "cliff",
              "sp:ray@2"
            ],
            "refs": [
              "player",
              "cliff",
              "sp:ray@2"
            ],
            "brief": "on the grassy bank by a wooden gate: the boy from the first reference sits catching his breath, the huge old dark-brown leather book with brass corners open in his lap, tiny silver lights above it, while the bearded man from the second reference kneels holding the calm cub from the third reference, and small silver sparkling specks float up from its fur toward the book, relieved and magical, NO other creature",
            "lines": [
              {
                "who": "narrator",
                "text": "Soul Dust! The Shard Book flashes, as if it has found a clue."
              },
              {
                "who": "kai",
                "text": "It found a clue! And I nearly ruined it all by running ahead."
              },
              {
                "who": "cliff",
                "text": "Yes. But then you stopped, thought, and asked for help."
              }
            ]
          }
        },
        {
          "battle": {
            "nodeId": "z1-nw1",
            "encounterKind": "wild",
            "kind": "zone_boss",
            "rivalName": "Wild Fernail",
            "rivalTitle": "Frightened",
            "squad": [
              {
                "species": "Fernail",
                "nickname": "Scared Fernail"
              },
              {
                "species": "Kobu",
                "nickname": "Bristle"
              },
              {
                "species": "Pikoto",
                "nickname": "Nettle"
              }
            ],
            "opponentCount": 1,
            "portrait": "Fernail",
            "shot": "wide",
            "artIsNew": true,
            "alt": "By the broken bridge, a frightened wild Fernail bursts out of the reeds, hissing at Cliff and the little Ray in his arms.",
            "refs": [
              "sp:fernail@2",
              "cliff",
              "sp:ray@2"
            ],
            "brief": "a grassy bank inside a wooden gate, reeds at the water: the snail creature from the first reference, drawn exactly like it, a LOW wide body flat on the ground, only knee-high to the man, lunges hissing out of the reeds, eye-stalks stiff; the bearded man from the second reference steps back, shielding the small cub from the third reference in his arms, wide shot, NO other creature",
            "story": "Then a wild Fernail, scared by the crash, hisses at the cub in Cliff's arms, and Kai steps in!",
            "dialogue": {
              "intro": "Hssss!",
              "playerWin": "Kai leaves it a clear path, and the Fernail slips into the reeds. Then, far off in the Gray, wheels squeak.",
              "playerLose": "The scared Fernail holds the riverbank. Try again!"
            }
          }
        },
        {
          "page": {
            "id": "b1-c3-key",
            "isNew": true,
            "twist": false,
            "caption": "The black Z.",
            "alt": "Cliff holds the little Ray and grips his big iron gate key, while far off in the gray trees a cart full of cages with a black Z rolls away and Kai stares after it.",
            "cast": [
              "cliff",
              "player",
              "sp:ray@2"
            ],
            "refs": [
              "cliff",
              "player",
              "sp:ray@2"
            ],
            "brief": "at a closed wooden gate by a gray misty forest: the bearded man from the first reference holds the small cub from the third reference in one arm and grips a big iron key in his other fist, while the boy from the second reference stares past him; far off in the gray trees, a small cart full of metal cages with a black Z painted on its side rolls away, its driver hidden by the mist; the narrow gap beside the gatepost visible, NO other creature",
            "lines": [
              {
                "who": "cliff",
                "text": "Tonight, that gap gets boarded up. I will not open this gate just because you are brave."
              },
              {
                "who": "narrator",
                "text": "One purple egg found. Eighteen more are still out there."
              },
              {
                "who": "narrator",
                "text": "Then a cart full of cages rolls through the mist. On its side: a black Z."
              }
            ]
          }
        }
      ],
      "adaptedFrom": "7776915e5b82",
      "zone": {
        "zoneId": "z3",
        "name": "The Gate to the Gray Forest",
        "element": "Nature",
        "story": "Cliff will not open his gate, and something cries for help on the other side."
      }
    },
    {
      "number": 4,
      "title": "The Black Z",
      "status": "draft",
      "items": []
    },
    {
      "number": 5,
      "title": "Names in the Mist",
      "status": "draft",
      "items": []
    },
    {
      "number": 6,
      "title": "The Cages",
      "status": "draft",
      "items": []
    },
    {
      "number": 7,
      "title": "The Last Apples",
      "status": "draft",
      "items": []
    },
    {
      "number": 8,
      "title": "The Machine at the Oldest Tree",
      "status": "draft",
      "items": []
    },
    {
      "number": 9,
      "title": "The Heart of the Forest",
      "status": "draft",
      "items": []
    },
    {
      "number": 10,
      "title": "A Light to Follow",
      "status": "draft",
      "items": []
    }
  ]
};
